import axios from "axios";

const BASE_URL =
  process.env.NODE_ENV === "development" ? "" : process.env.REACT_APP_API_BASE_URL || "";

const ARTICLES_URL = `${BASE_URL}/api/articles`;
const API_KEY = process.env.REACT_APP_API_KEY;

const getAuthHeaders = () => {
  return { "X-API-KEY": API_KEY };
};

const getArticles = async () => {
  const response = await axios.get(ARTICLES_URL, { headers: getAuthHeaders() });
  return response.data;
};

const getArticleBySlug = async (slug) => {
  const response = await axios.get(`${ARTICLES_URL}/${slug}`);
  return response.data;
};

const createArticle = async (articleData) => {
  const response = await axios.post(ARTICLES_URL, articleData, {
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
};

const getArticleWithNeighbors = async (slug) => {
  const response = await axios.get(`${ARTICLES_URL}/${slug}/neighbors`);
  return response.data;
};

const getRecentsArticles = async (limit = 2) => {
  const response = await axios.get(`${ARTICLES_URL}/recents?limit=${limit}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

const deleteArticle = async (slug) => {
  const { data } = await axios.delete(`${ARTICLES_URL}/${encodeURIComponent(slug)}`, {
    withCredentials: true,
  });
  return data;
};

const updateArticleMedia = async (slug, mediaArray) => {
  const { data } = await axios.patch(
    `${ARTICLES_URL}/${encodeURIComponent(slug)}/media`,
    mediaArray,
    { headers: { "Content-Type": "application/json" }, withCredentials: true }
  );
  return data;
};

export default {
  getArticles,
  createArticle,
  getArticleBySlug,
  getArticleWithNeighbors,
  getRecentsArticles,
  deleteArticle,
  updateArticleMedia,
};
